<template>
  <div>
    <StepHeader :title="'Income Details\nPlease Select One:'"/>
    <StepContent
      width="md"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        :value="income_type"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="$emit('next')"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Your income details help us make sure your vehicle payments are easy and affordable.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepHeader from '@/components/common/step/StepHeader'
import StepTooltip from '@/components/common/step/StepTooltip'

export default {
  name: 'employment-income-type',

  components: {
    AppButtonContinue,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader,
    StepTooltip
  },

  data () {
    return {
      datalayerStepName: 'income_details',
      fieldName: 'income_type',
      defaultSelected: true,
      buttons: [{
        text: 'I Know My Annual Salary',
        value: 'Annual',
        datalayer: 'income_annual_salary'
      }, {
        text: 'I Know My Hourly Wage',
        value: 'Hourly',
        datalayer: 'income_hourly_wage'
      }, {
        text: 'I Know My Monthly Income',
        value: 'Monthly',
        datalayer: 'income_monthly_income'
      }, {
        text: 'Other',
        value: 'Other',
        datalayer: 'income_other'
      }]
    }
  },

  computed: {
    income_type () {
      return this.$store.state.application[this.fieldName]
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    selectedButton () {
      if (!this.income_type) return
      for (let i in this.buttons) {
        if (this.buttons[i].value === this.income_type) {
          return this.buttons[i]
        }
      }
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      const datalayer = this.selectedButton.datalayer
      return `${datalayer}${this.defaultSelected ? '_default' : ''}`
    }
  },

  // Created
  created () {
    if (!this.income_type) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    } else {
      this.defaultSelected = false
    }
  },

  methods: {
    handleClick (event) {
      if (event !== this.income_type) {
        this.$store.updateApplication('income_value', undefined)
        this.$store.updateApplication('income_hours', undefined)
      }

      this.$store.updateApplication(this.fieldName, event)
      this.defaultSelected = false
    }
  }
}
</script>

<style>
</style>
